module.exports = __webpack_public_path__ + "img/css-3-logo.62cc9e7d.svg";